if (!customElements.get('lookbook-modal-dialog')) {
  customElements.define(
    'lookbook-modal-dialog',
    class LookbookModalDialog extends ModalDialog {
      show(opener) {
        // a11y: trapFocus() が子要素へフォーカスする前に
        // aria-hidden/inert を解除する
        this.removeAttribute('aria-hidden');
        this.removeAttribute('inert');
        super.show(opener);
      }

      hide(...args) {
        super.hide(...args);
        // a11y: 閉じた状態では AT から隠し、フォーカスも不可能にする
        this.setAttribute('aria-hidden', 'true');
        this.setAttribute('inert', '');
      }
    }
  );
}

